import ChartElearning from "../../../../src/client/katnh/interactions/elearning/Chart.js";
import ElearningModuleA from "../../../../src/client/katnh/elearning-module-a.json";
import * as React from 'react';
export default {
  ChartElearning,
  ElearningModuleA,
  React
};